// extracted by mini-css-extract-plugin
export default {"imageWrapper":"gQ-z","twoColumnImage":"hQ-z"};